import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Radius } from '../types/Radius';

export function composeRadiusClasses(radius: Adaptive<Radius>): string {
    if (typeof radius === 'object') {
        return clsx(
            radius.base && `rounded-${radius.base}`,
            radius.sm && `sm:rounded-${radius.sm}`,
            radius.md && `md:rounded-${radius.md}`,
            radius.lg && `lg:rounded-${radius.lg}`,
            radius.xl && `xl:rounded-${radius.xl}`,
            radius['2xl'] && `2xl:rounded-${radius['2xl']}`
        );
    }

    return `rounded-${radius}`;
}
